import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { SessionProvider } from './session/useSession';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Suppress the benign "ResizeObserver loop" browser warning from appearing
// as a fatal error in CRA's dev overlay. It is harmless — the browser skips
// the frame and continues. MUI grid/flex containers commonly trigger it.
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
      e.message === 'ResizeObserver loop limit exceeded') {
    e.stopImmediatePropagation();
  }
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <SessionProvider>
    <App />
  </SessionProvider>
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log('[PWA] Service worker registered successfully:', registration);
  },
  onUpdate: () => {
    console.log('[PWA] Update detected — reloading automatically');
    // Reload is handled automatically via the controllerchange event in serviceWorkerRegistration
  },
});
